import PaymentCalculationScreen from './PaymentCalculationScreen';

export default PaymentCalculationScreen;
